import { render, staticRenderFns } from "./edit-archived-settings-dialog.vue?vue&type=template&id=6a9275c7&scoped=true&"
import script from "./edit-archived-settings-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-archived-settings-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9275c7",
  null
  
)

export default component.exports